import { c as _c } from "react/compiler-runtime";
import type { DocumentKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useDocumentText = () => {
  const $ = _c(44);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "id_document"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t(_temp6);
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t(_temp7);
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t) {
    t8 = t(_temp8);
    $[15] = t;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t) {
    t9 = t(_temp9);
    $[17] = t;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t) {
    t10 = t(_temp10);
    $[19] = t;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t) {
    t11 = t(_temp11);
    $[21] = t;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t) {
    t12 = t(_temp12);
    $[23] = t;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t) {
    t13 = t(_temp13);
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t(_temp14);
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t1 || $[30] !== t10 || $[31] !== t11 || $[32] !== t12 || $[33] !== t13 || $[34] !== t14 || $[35] !== t2 || $[36] !== t3 || $[37] !== t4 || $[38] !== t5 || $[39] !== t6 || $[40] !== t7 || $[41] !== t8 || $[42] !== t9) {
    const map = {
      id_card: t1,
      drivers_license: t2,
      passport: t3,
      visa: t4,
      permit: t5,
      residence_document: t6,
      voter_identification: t7,
      ssn_card: t8,
      lease: t9,
      bank_statement: t10,
      utility_bill: t11,
      proof_of_address: t12,
      passport_card: t13,
      custom: t14
    };
    t15 = documentKind => map[documentKind];
    $[29] = t1;
    $[30] = t10;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
    $[34] = t14;
    $[35] = t2;
    $[36] = t3;
    $[37] = t4;
    $[38] = t5;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
    $[42] = t9;
    $[43] = t15;
  } else {
    t15 = $[43];
  }
  return t15;
};
export default useDocumentText;
function _temp($) {
  return $.id_card;
}
function _temp2($_0) {
  return $_0.drivers_license;
}
function _temp3($_1) {
  return $_1.passport;
}
function _temp4($_2) {
  return $_2.visa;
}
function _temp5($_3) {
  return $_3.permit;
}
function _temp6($_4) {
  return $_4.residence_document;
}
function _temp7($_5) {
  return $_5.voter_identification;
}
function _temp8($_6) {
  return $_6.ssn_card;
}
function _temp9($_7) {
  return $_7.lease;
}
function _temp10($_8) {
  return $_8.bank_statement;
}
function _temp11($_9) {
  return $_9.utility_bill;
}
function _temp12($_10) {
  return $_10.proof_of_address;
}
function _temp13($_11) {
  return $_11.passport_card;
}
function _temp14($_12) {
  return $_12.passport_card;
}